// extracted by mini-css-extract-plugin
module.exports = {"list":"SelectedFiltersList_list__mNkpJ","item":"SelectedFiltersList_item__HOrRu"};